import React, { Component } from "react";
import "./cardsection.css";

export class CardSection extends Component {
  render() {
    return (
      <div>
        <div className="container-fluid">
          <div className="coin-name">
            <h1>{this.props.coinName}</h1>
          </div>
          <section className="row justify-content-center">
            <div className="col-10 col-md-2 card  text-white text-center m-2">
              <div className="card-body">
                <h6 className="card-title">Market Cap 24Hrs</h6>
                <p className="card-text text-primary">{this.props.mCap24} %</p>
              </div>
            </div>
            <div className="col-10 col-md-2 card text-white text-center m-2">
              <div className="card-body">
                <h6 className="card-title">All Time High</h6>
                <p className="card-text text-success">${this.props.atl}</p>
              </div>
            </div>

            <div className="col-10 col-md-2 card text-white text-center m-2">
              <div className="card-body">
                <h6 className="card-title">Positive Sentiments </h6>
                <p className="card-text text-info">{this.props.sentiment} %</p>
              </div>
            </div>
            <div className="col-10 col-md-2 card text-white text-center  m-2">
              <div className="card-body">
                <h6 className="card-title"> High 24Hrs </h6>
                <p className="card-text text-success">${this.props.high24}</p>
              </div>
            </div>
            <div className="col-10 col-md-2 card text-white text-center m-2">
              <div className="card-body">
                <h6 className="card-title"> Low 24Hrs </h6>
                <p className="card-text text-danger">${this.props.low24}</p>
              </div>
            </div>
          </section>
        </div>
        <div>
          <div className="digi-sec text-white text-center"> Current Price</div>
          <div className="below-digi">${this.props.currentPrice}</div>
        </div>
      </div>
    );
  }
}

export default CardSection;
